import { createAction } from 'redux-actions'

export const setSkuInformation = createAction(
  'FIND_LOWER_PRICE/SET_SKU_INFORMATION',
  skuInformation => ({ skuInformation })
)
